// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__lYcfo","label":"Category_label__HdHIa","content":"Category_content__26vCX","header":"Category_header__26xT7","location":"Category_location__1_9N0"};